var maps = [
	[
		"                                      ",
		"                                      ",
		"                                      ",
		"                                      ",
		"                                      ",
		"     &   =*=%=                        ",
		"                                      ",
		"                            -+        ",
		"                    ^   ^   ()        ",
		"==============================   =====",
	],
	[
		"£                                       £",
		"£                                       £",
		"£                                       £",
		"£                                       £",
		"£                                       £",
		"£        @@@@@@              x x        £",
		"£                          x x x        £",
		"£                        x x x x  x   -+£",
		"£               z   z  x x x x x  x   ()£",
		"!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",
	],
	[
		"                                      ",
		"                                      ",
		"      ^       ^                       ",
		"                                      ",
		"   ***==***==***      &               ",
		"                                      ",
		"                         -+           ",
		"                z    z   ()           ",
		"==============================    ====",
		"==============================    ====",
	],
	[
		"£                                       £",
		"£        x   x   x   x                  £",
		"£              x   x   x                £",
		"£                  x   x   x            £",
		"£   z  z   z   z     @@@@               £",
		"£                             -+        £",
		"£                             ()        £",
		"£                                       £",
		"!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",
		"!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",
	],
	[
		"                                      ",
		"          =*=%=                       ",
		"                                      ",
		"     ^   ^   ^                        ",
		"                                      ",
		"                     z   z            ",
		"                              -+       ",
		"                              ()       ",
		"====================    ===============",
		"====================    ===============",
	],
	[
		"£         x     x      x     x         £",
		"£    x         x     x        x        £",
		"£  z   z   z   z   z   z   z   z       £",
		"£                                       £",
		"£        @@@         @@@               £",
		"£                         -+           £",
		"£                         ()           £",
		"£                                       £",
		"!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",
		"!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",
	],
	[
		"                                      ",
		"  &                                   ",
		"     ==*==*==*==*==                   ",
		"                                      ",
		"             ^   ^                    ",
		"                                      ",
		"                        z  z          ",
		"                              -+       ",
		"                              ()       ",
		"=======================================",
	],
	[
		"£     x x x x x x x x x x x x x x     £",
		"£   z   z   z   z   z   z   z   z     £",
		"£                                       £",
		"£    @@@@@@@@         @@@@@@@@         £",
		"£                        -+            £",
		"£                        ()            £",
		"£                                       £",
		"!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",
		"!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",
		"!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",
	],
	[
		"                                      ",
		"       ^         ^        ^            ",
		"                                      ",
		"   =*=%=   =*=%=   =*=%=               ",
		"                                      ",
		"             z     z                   ",
		"                        -+             ",
		"                        ()             ",
		"================   ====================",
		"================   ====================",
	],
	[
		"£      x    x    x    x    x           £",
		"£  z z   z z   z z   z z   z z         £",
		"£                                       £",
		"£     @@@   @@@   @@@                   £",
		"£                              -+       £",
		"£                              ()       £",
		"£                                       £",
		"!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",
		"!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",
		"!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",
	],
	[
		"                                      ",
		"  &                                   ",
		"     ==*==*==*==*==                   ",
		"                                      ",
		"          ^    ^    ^                 ",
		"                                      ",
		"             z     z     z            ",
		"                          -+           ",
		"                          ()           ",
		"=======================================",
	],
	[
		"£                                       £",
		"£  x   x   x   x   x   x   x   x       £",
		"£     z   z   z   z   z   z   z        £",
		"£                                       £",
		"£    @@@@       @@@@                    £",
		"£                             -+        £",
		"£                             ()        £",
		"£                                       £",
		"!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",
		"!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",
	],
];

export { maps };
